<template lang="pug">
v-card.mb-3
  v-card-title.grey.lighten-4(v-if="extra && extra.options.show_panel_title") {{extra.name}}
  v-card-text
    template(v-for="(crumb, crumbI) in breadcrumb")
      div.grey.lighten-3
        v-btn(icon @click="breadcrumb = breadcrumb.slice(0, crumbI)" :disabled="!!edit"): v-icon arrow_drop_up
        |  {{selectVorgaben.byId[crumb].name}}
      v-divider
    .pb-3
    template(v-for="v in currentChildren")
      div(:class="edit && edit.id == v.id ? 'primary lighten-5' : (isLeaf(v.id) ? 'green lighten-5' : '')")
        v-btn(icon @click="breadcrumb.push(v.id)" :disabled="!!edit"): v-icon arrow_right
        span(v-if="breadcrumb.length === 0")  {{v.id}}:
        span  {{v.name}}&#32;
        v-btn(@click="editVorgang(v)" icon :disabled="!!edit"): v-icon edit
      v-divider
    template(v-if="edit")
      v-layout(row wrap)
        v-flex(xs12): v-select(label="Unterauswahl von" v-model="edit.parentId" :items="possibleParents(selectVorgaben.list, edit.id)" item-text="label" item-value="id")
        v-flex(xs12): v-text-field(label="Name" v-model="edit.name")
        v-flex(xs12): v-text-field(label="Betreff" v-model="edit.betreff" persistent-hint :hint="effectiveValues.betreff")
        v-flex(xs12): v-combobox(label="Hilfe zum selbständigen Lösen" v-model="edit.contentsToHelp" :items="itContents" item-text="title" item-value="id" :search-input.sync="searchContents" hide-selected multiple deletable-chips chips :hint="`${effectiveValues.contentsToHelp.map(c => itContents.find(i => i.id == c).title).join(' --- ')}`" persistent-hint)
        v-flex(xs12): tiptap-input(label="Beschreibung" v-model="edit.beschreibung")
        v-flex(xs12): v-select(label="Prio" v-model="edit.prio" :items="prios" clearable :hint="`${effectiveValues.prio||''}`" persistent-hint)
        v-flex(xs12): v-combobox(label="Tags" v-model="edit.tags" :items="itTicketTags" :search-input.sync="searchTags" hide-selected multiple deletable-chips chips :hint="`${effectiveValues.tags.join(', ')}`" persistent-hint)
        v-flex(xs12): v-select(label="Bearbeiter" v-model="edit.personId" :items="itTicketBearbeiter" clearable item-text="vollerName" item-value="id" :hint="effectiveValues.person.vollerName" persistent-hint)
        v-flex(xs12): v-combobox(label="Team" v-model="edit.team" :items="itTicketTeams" :search-input.sync="searchTeams" hide-selected :hint="effectiveValues.team" persistent-hint)
        v-flex(xs12): radio-group(label="Formular" row v-model="edit.formular" :items="jaNeinDefault" :hint="`${effectiveValues.formular ? 'Ja' : 'Nein'} ${isLeaf(edit.id) ? '' : '(Nein: Hat Unterpunkte)'}`" persistent-hint)
        v-flex(xs12): radio-group(label="Formular Betreff" row v-model="edit.formularBetreff" :items="jaNeinDefault" :hint="effectiveValues.formularBetreff ? 'Ja' : 'Nein'" persistent-hint)
        v-flex(xs12): radio-group(label="Formular Text" row v-model="edit.formularText" :items="jaNeinDefault" :hint="effectiveValues.formularText ? 'Ja' : 'Nein'" persistent-hint)
        v-flex(xs12): radio-group(label="Formular Dateien" row v-model="edit.formularDateien" :items="jaNeinDefault" :hint="effectiveValues.formularDateien ? 'Ja' : 'Nein'" persistent-hint)
        v-flex(xs12): radio-group(label="Braucht Freigabe" row v-model="edit.brauchtFreigabe" :items="jaNeinDefault" :hint="`${effectiveValues.brauchtFreigabe ? 'Ja' : 'Nein'}`" persistent-hint)

      v-layout
        v-btn(@click="saveVorgang" :loading="loading > 0" color="primary") Speichern
        v-btn(@click="cancelVorgang") Abbrechen
        v-spacer
        v-btn(@click="destroyVorgang" :loading="loadingDestroy > 0" :disabled="!!(selectVorgaben.children[edit.id] && selectVorgaben.children[edit.id].length)") Löschen
    template(v-else)
      v-btn(@click="newVorgang" icon)
        v-icon add

</template>

<script>
import gql from "graphql-tag";
import GraphqlErrorObject from "../../mixins/graphql-error-object.js";
import { sortBy, uniq, flatten } from "lodash";

export default {
  props: ["extra"],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      edit: null,
      searchTags: null,
      searchTeams: null,
      searchContents: null,
      breadcrumb: [],
      itTicketVorgaben: [],
      itTicketTags: [],
      itContents: [],
      itTicketTeams: [],
      itHelpContentsCategoryId: null,
      itTicketBearbeiter: [],
      loading: 0,
      loadingDestroy: 0,
      tree: null,
      jaNeinDefault: [
        { text: "k.A.", value: null },
        { text: "Ja", value: true },
        { text: "Nein", value: false },
      ],
      prios: [
        { text: "5 Kritisch", value: 5 },
        { text: "4 Hoch", value: 4 },
        { text: "3 Normal", value: 3 },
        { text: "2 Niedrig", value: 2 },
        { text: "1 NiceToHave", value: 1 }
      ]
    };
  },
  apollo: {
    itTicketVorgaben: {
      query: gql`
        query ExtraItTicketVorgabenBearbeitenVue {
          itTicketVorgaben {
            id
            name
            betreff
            beschreibung
            ancestorIds
            parentId
            prio
            tags
            team
            personId
            formular
            formularBetreff
            formularText
            formularDateien
            brauchtFreigabe
            contentsToHelp: contents{
              id
              title
            }
          }
        }
      `
    },
    itTicketTags: gql`query ExtraItTicketVorgabenBearbeitenVueTags {
      itTicketTags
    }`,
    itTicketTeams: gql`query ExtraItTicketVorgabenBearbeitenVueTeams {
      itTicketTeams
    }`,
    itTicketBearbeiter: gql`query ExtraItTicketVorgabenBearbeitenVueBearbeiter {
      itTicketBearbeiter {
        id
        vollerName
      }
    }`,
    itHelpContentsCategoryId: gql`query ExtraItTicketVorgabenBearbeitenVueCategoryId {
      itHelpContentsCategoryId
    }`,
    itContents: {
      query: gql`query ExtraItTicketVorgabenBearbeitenVueContents {
        itContents: beitraege {
          id
          title
        }
      }`,
      variables() {
        return {
          itHelpContentsCategoryId: this.itHelpContentsCategoryId
        }
      },
      skip() {
        return !this.itHelpContentsCategoryId
      }
    },
  },
  computed: {
    selectVorgaben() {
      const vorgaben = this.itTicketVorgaben.map(v => ({
        ...v,
        label: `${v.ancestorIds.map(() => " -").join("")} ${v.name}`,
        sort: v.ancestorIds.length ? v.ancestorIds.join("/") : "0"
      }));
      let nodes = sortBy(vorgaben, ["sort", "name"]);

      const byId = {};
      let children = {};
      nodes.forEach(node => {
        byId[node.id] = node;
        if (children[node.parentId]) {
          children[node.parentId].push(node.id);
        } else {
          children[node.parentId] = [node.id];
        }
      });
      function buildTree(nodes, current, list) {
        list.push(current);
        if (nodes[current]) {
          const node = {};
          nodes[current].forEach(id => {
            node[id] = buildTree(nodes, id, list);
          });
          return node;
        } else {
          return {};
        }
      }
      let list = [];
      const tree = buildTree(children, null, list);
      list.shift();
      list = list.map(id => byId[id]);
      return { tree, list, children, byId };
    },
    currentChildren() {
      const vorgaben = this.selectVorgaben;
      return (
        vorgaben.children[
          this.breadcrumb[this.breadcrumb.length - 1] || null
        ] || []
      ).map(id => vorgaben.byId[id]);
    },
    effectiveValues() {
      const vorgaben = this.selectVorgaben;
      const ancestors = this.breadcrumb.map(id => vorgaben.byId[id]).reverse()
      const edit = this.edit
      ancestors.unshift(edit)
      ancestors.push({
        prio: 3,
        tags: [],
        contentsToHelp: [],
        personId: null,
        team: null,
        formular: true,
        formularBetreff: false,
        formularText: true,
        formularDateien: true,
        brauchtFreigabe: false,
      })
      const personId = ancestors.map(a => a.personId).find(id => id)
      const formularBetreff = ancestors.map(a => a.formularBetreff).find(f => f !== null)

      return {
        betreff: formularBetreff ? `${edit.betreff ? `${edit.betreff}: ` : ''}Usereingabe` : `${edit.betreff || edit.name || ''}`,
        prio: ancestors.map(a => a.prio).find(prio => prio),
        tags: uniq(flatten(ancestors.map(a => a.tags))).sort(),
        contentsToHelp: uniq(flatten(ancestors.map(a => a.contentsToHelp.map(c => c.id)))).sort(),
        personId: personId,
        person: this.itTicketBearbeiter.find(b => b.id == personId) || { id: personId, vollerName: `${personId || ''}` },
        team: ancestors.map(a => a.team).find(team => team),
        formular: ancestors.map(a => a.formular).find(f => f !== null),
        formularBetreff,
        formularText: ancestors.map(a => a.formularText).find(f => f !== null),
        formularDateien: ancestors.map(a => a.formularDateien).find(f => f !== null),
        brauchtFreigabe: ancestors.map(a => a.brauchtFreigabe).find(f => f !== null),
      }
    },
  },
  methods: {
    possibleParents(items, current) {
      return items.map(item => ({
        ...item,
        disabled: item.id == current || item.ancestorIds.indexOf(current) >= 0
      }));
    },
    isLeaf(id) {
      const children = this.selectVorgaben.children
      return !(children[id] && children[id].length)
    },
    newVorgang() {
      this.edit = {
        name: "",
        betreff: "",
        contentsToHelp: [],
        parentId: this.breadcrumb[this.breadcrumb.length - 1] || null,
        prio: null,
        tags: [],
        personId: null,
        team: "",
        formular: null,
        formularBetreff: null,
        formularText: null,
        formularDateien: null,
        brauchtFreigabe: null,
      };
    },
    cancelVorgang() {
      this.edit = null;
    },
    editVorgang(vorgang) {
      this.edit = { ...vorgang, tags: vorgang.tags.map(t => t) };
    },
    saveVorgang() {
      this.gqlClearAllErrors();
      this.loading++;
      this.$apollo
        .mutate({
          mutation: this.edit.id
            ? gql`
                mutation(
                  $id: ID!
                  $parentId: ID
                  $name: String
                  $betreff: String
                  $beschreibung: String
                  $prio: Int
                  $tags: [String]
                  $team: String
                  $personId: ID
                  $formular: Boolean
                  $formularBetreff: Boolean
                  $formularText: Boolean
                  $formularDateien: Boolean
                  $brauchtFreigabe: Boolean
                  $contentsToHelp: [ID]
                ) {
                  itTicketVorgabeUpdate(
                    id: $id
                    parentId: $parentId
                    name: $name
                    betreff: $betreff
                    beschreibung: $beschreibung
                    prio: $prio
                    tags: $tags
                    team: $team
                    personId: $personId
                    formular: $formular
                    formularBetreff: $formularBetreff
                    formularText: $formularText
                    formularDateien: $formularDateien
                    brauchtFreigabe: $brauchtFreigabe
                    contentsToHelp: $contentsToHelp
                  ) {
                    id
                  }
                }
              `
            : gql`
                mutation(
                  $parentId: ID
                  $name: String
                  $betreff: String
                  $beschreibung: String
                  $prio: Int
                  $tags: [String]
                  $team: String
                  $personId: ID
                  $formular: Boolean
                  $formularBetreff: Boolean
                  $formularText: Boolean
                  $formularDateien: Boolean
                  $brauchtFreigabe: Boolean
                  $contentsToHelp: [ID]
                ) {
                  itTicketVorgabeCreate(
                    parentId: $parentId
                    name: $name
                    betreff: $betreff
                    beschreibung: $beschreibung
                    prio: $prio
                    tags: $tags
                    team: $team
                    personId: $personId
                    formular: $formular
                    formularBetreff: $formularBetreff
                    formularText: $formularText
                    formularDateien: $formularDateien
                    brauchtFreigabe: $brauchtFreigabe
                    contentsToHelp: $contentsToHelp
                  ) {
                    id
                  }
                }
              `,
          variables: { ...this.edit, contentsToHelp: this.edit.contentsToHelp.map(a => a.id)}
        })
        .then(data => {
          this.loading--;
          this.edit = null;
          this.$apollo.queries.itTicketVorgaben.refetch();
          this.$apollo.queries.itTicketTeams.refetch();
          this.$apollo.queries.itTicketTags.refetch();
        })
        .catch(error => {
          this.gqlAddErrors(error);
          this.loading--;
        });
    },
    destroyVorgang() {
      if (!confirm(`${this.edit.name} löschen?`)) {
        return;
      }
      this.gqlClearAllErrors();
      this.loadingDestroy++;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!) {
              itTicketVorgabeDestroy(id: $id) {
                success
              }
            }
          `,
          variables: { id: this.edit.id }
        })
        .then(data => {
          this.loadingDestroy--;
          this.edit = null;
          this.$apollo.queries.itTicketVorgaben.refetch();
        })
        .catch(error => {
          this.gqlAddErrors(error);
          alert('Ein Fehler is aufgetreten.')
          this.loadingDestroy--;
        });
    }
  }
};
</script>
